// extracted by mini-css-extract-plugin
export default {"overallContainer":"Home_overallContainer__2BLDJ"};